import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Check } from "lucide-react";

const LEVELS = ["CI", "CP", "CE1", "CE2", "CM1", "CM2"];
const ORGS = [["simple", "Classe simple"], ["multigrade", "Multigrade"], ["double_flux", "Double flux"]];

export function previewClasses({ organisation, niveaux, flux, lettre }) {
  if (!niveaux.length) return [];
  if (organisation === "double_flux") {
    const g = (flux || "").split(/[,;/]/).map((x) => x.trim()).filter(Boolean);
    return niveaux.flatMap((n) => (g.length ? g : ["A", "B"]).map((f) => `${n} — Flux ${f}`));
  }
  if (organisation === "multigrade") return niveaux;
  return niveaux.length === 1 && lettre ? [`${niveaux[0]} ${lettre}`] : niveaux;
}

export default function TeacherClassesPicker({ value, onChange }) {
  const set = (patch) => onChange({ ...value, ...patch });
  const toggle = (lv) => {
    const has = value.niveaux.includes(lv);
    set({ niveaux: has ? value.niveaux.filter((x) => x !== lv) : [...value.niveaux, lv].sort((a, b) => LEVELS.indexOf(a) - LEVELS.indexOf(b)) });
  };
  const preview = previewClasses(value);
  return (
    <div className="p-3 bg-[#FCF8E6]/50 border border-[#E6B800]/30 rounded-lg space-y-3" data-testid="teacher-classes-picker">
      <div className="text-xs font-semibold text-[#5C736A] uppercase tracking-wider">Classes assignées</div>
      <div className="grid grid-cols-3 gap-2">
        {ORGS.map(([v, l]) => (
          <button type="button" key={v} onClick={() => set({ organisation: v })} data-testid={`tc-org-${v}`}
            className={`text-xs sm:text-sm font-semibold py-2 rounded-lg border-2 transition-colors ${value.organisation === v ? "border-[#1F7A63] bg-[#E8F2EF] text-[#1F7A63]" : "border-[#E2E8F0] bg-white"}`}>{l}</button>
        ))}
      </div>
      <div className="flex flex-wrap gap-2">
        {LEVELS.map((lv) => {
          const on = value.niveaux.includes(lv);
          return (
            <button type="button" key={lv} onClick={() => toggle(lv)} data-testid={`tc-level-${lv}`}
              className={`h-9 px-3 rounded-full border text-sm font-semibold transition-colors ${on ? "bg-[#1F7A63] border-[#1F7A63] text-white" : "bg-white border-[#E2E8F0]"}`}>
              {on && <Check className="w-3 h-3 inline mr-1" />}{lv}
            </button>
          );
        })}
      </div>
      {value.organisation === "double_flux" && (
        <div><Label>Groupes / flux</Label><Input value={value.flux} onChange={(e) => set({ flux: e.target.value })} placeholder="A, B" data-testid="tc-flux" /></div>
      )}
      {value.organisation === "simple" && value.niveaux.length === 1 && (
        <div><Label>Lettre (opt.)</Label><Input maxLength={1} value={value.lettre} onChange={(e) => set({ lettre: e.target.value.toUpperCase().slice(0, 1) })} placeholder="A, B…" data-testid="tc-lettre" /></div>
      )}
      <div className="text-xs text-[#5C736A]" data-testid="tc-preview">
        Classe(s) créée(s) : <span className="font-semibold text-[#1F7A63]">{preview.join(", ") || "—"}</span>
      </div>
    </div>
  );
}
